'use strict';
import noop from 'lodash/noop';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {FormField, INPUT_TYPES} from '../../../components/forms/FormField';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';


// TODO: set up camera override settings
export function BaseProjectFormView(props) {
  const canEdit = props.canEdit || {};
  const constraints = props.constraints || {};
  const internalModel = props.internalModel || {};
  const onChange = props.onChange || {};

  const handleChangeName = onChange.name || noop;
  const handleChangeDescription = onChange.description || noop;
  const handleChangeIsPrivate = onChange.isPrivate || noop;

  return (
    <form
      className={classNames("ProjectForm", props.className)}
      onSubmit={props.onSave}
    >
      <input
        type="submit"
        hidden={true}
      />
      <FormField
        className={classNames("ProjectForm__field", props.fieldClass)}
        type={INPUT_TYPES.text}
        label={props.nameLabel}
        value={internalModel.name}
        disabled={!canEdit.name}
        validateImmediately={props.validateImmediately}
        isEditing={props.isEditing}
        isSaving={props.isSaving}
        constraints={constraints.name}
        onChange={handleChangeName}
        isErrorAfterLabel={true}
      />
      <FormField
        className={classNames("ProjectForm__field", props.fieldClass)}
        type={INPUT_TYPES.text_long}
        label={props.descriptionLabel}
        value={internalModel.description}
        validateImmediately={props.validateImmediately}
        isEditing={props.isEditing}
        isSaving={props.isSaving}
        constraints={constraints.description}
        onChange={handleChangeDescription}
        isErrorAfterLabel={true}
      />
      {props.showIsPrivate ? (
        <FormField
          className={classNames("ProjectForm__field__makePrivate", props.fieldClass, {
            ProjectForm__field__makePrivate_disabled: !canEdit.isPrivate,
          })}
          type={INPUT_TYPES.checkbox}
          label={props.isPrivateLabel}
          value={internalModel.isPrivate}
          disabled={!canEdit.isPrivate}
          trueValue={props.yesLabel}
          falseValue={props.noLabel}
          validateImmediately={props.validateImmediately}
          isEditing={props.isEditing}
          isSaving={props.isSaving}
          constraints={constraints.isPrivate}
          onChange={handleChangeIsPrivate}
          isCustomCheckmark={true}
          customCheckmarkClass="ProjectForm__field__makePrivate__checkmark"
          fieldTitleClass="ProjectForm__field__makePrivate__title"
        />
      ) : null}
    </form>
  );
}

BaseProjectFormView.propTypes = {
  className: T.string,
  /** @type {String} fieldClass The class applied to each field */
  fieldClass: T.string,
  showIsPrivate: T.bool,

  // values
  model: T.object,
  internalModel: T.object,

  canEdit: T.object,
  constraints: T.object,

  // Events
  onChange: T.object,
  onSave: T.func,

  // Form State
  isEditing: T.bool,
  isSaving: T.bool,

  nameLabel: T.string,
  descriptionLabel: T.string,
  isPrivateLabel: T.string,
  yesLabel: T.string,
  noLabel: T.string,
};

export const ProjectFormView = I18nComponent(BaseProjectFormView, [
  {code: 'projects.properties.name.label', prop: 'nameLabel'},
  {code: 'projects.properties.description.label', prop: 'descriptionLabel'},
  {code: 'projects.create.private.label', prop: 'isPrivateLabel'},
  {code: 'default.yes.label', prop: 'yesLabel'},
  {code: 'default.no.label', prop: 'noLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/projects/components/ProjectForm/ProjectFormView.js